import { render, staticRenderFns } from "./CardQuantity.vue?vue&type=template&id=f3070ae6"
import script from "./CardQuantity.vue?vue&type=script&lang=js"
export * from "./CardQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports